import { render, staticRenderFns } from "./DocumentControlSection.vue?vue&type=template&id=fef53c26&"
import script from "./DocumentControlSection.vue?vue&type=script&lang=js&"
export * from "./DocumentControlSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports